import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const labelCls =
  "text-zinc-500 text-xs font-bold uppercase tracking-[0.15em]";
const inputCls =
  "mt-1 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white";
const textareaCls = `${inputCls} min-h-[80px] resize-none`;

export default function AnamnesiNutritionSection({ form, onChange }) {
  return (
    <>
      <p className="label-overline mb-3">ALIMENTAZIONE</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div>
          <Label className={labelCls}>Regime Alimentare</Label>
          <Select
            value={form.diet_type || "unset"}
            onValueChange={(v) => onChange("diet_type", v === "unset" ? "" : v)}
          >
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="anamnesi-diet_type"
            >
              <SelectValue placeholder="Seleziona" />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="unset" className="text-white">-</SelectItem>
              <SelectItem value="onnivoro" className="text-white">Onnivoro</SelectItem>
              <SelectItem value="vegetariano" className="text-white">Vegetariano</SelectItem>
              <SelectItem value="vegano" className="text-white">Vegano</SelectItem>
              <SelectItem value="pescetariano" className="text-white">Pescetariano</SelectItem>
              <SelectItem value="chetogenica" className="text-white">Chetogenica</SelectItem>
              <SelectItem value="mediterranea" className="text-white">Mediterranea</SelectItem>
              <SelectItem value="altro" className="text-white">Altro</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className={labelCls}>Pasti al giorno</Label>
          <Input
            type="number"
            value={form.meals_per_day}
            onChange={(e) => onChange("meals_per_day", e.target.value)}
            className={inputCls}
            placeholder="es. 5"
            data-testid="anamnesi-meals_per_day"
          />
        </div>
        <div>
          <Label className={labelCls}>Integratori</Label>
          <Input
            value={form.supplements}
            onChange={(e) => onChange("supplements", e.target.value)}
            className={inputCls}
            placeholder="es. Proteine, Creatina"
            data-testid="anamnesi-supplements"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div>
          <Label className={labelCls}>Intolleranze alimentari</Label>
          <Textarea
            value={form.food_intolerances}
            onChange={(e) => onChange("food_intolerances", e.target.value)}
            className={textareaCls}
            placeholder="es. Lattosio, Glutine..."
            data-testid="anamnesi-food_intolerances"
          />
        </div>
        <div>
          <Label className={labelCls}>Allergie alimentari</Label>
          <Textarea
            value={form.food_allergies}
            onChange={(e) => onChange("food_allergies", e.target.value)}
            className={textareaCls}
            placeholder="es. Frutta secca, Crostacei..."
            data-testid="anamnesi-food_allergies"
          />
        </div>
        <div className="sm:col-span-2">
          <Label className={labelCls}>Note alimentazione</Label>
          <Textarea
            value={form.nutrition_notes}
            onChange={(e) => onChange("nutrition_notes", e.target.value)}
            className={textareaCls}
            placeholder="Abitudini alimentari, orari pasti, preferenze..."
            data-testid="anamnesi-nutrition_notes"
          />
        </div>
      </div>
    </>
  );
}
